let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bnvf0")).then(() => parcelRequire('8bn0J'));